module.exports = global["jQuery"] = require("-!C:\\WREPO\\Web.Projects\\Web.Rusmebel\\frontend\\node_modules\\source-map-loader\\index.js!C:\\WREPO\\Web.Projects\\Web.Rusmebel\\frontend\\node_modules\\source-map-loader\\index.js!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/source-map-loader!./~/jquery/dist/jquery.js-exposed
// module id = 4
// module chunks = 0